import { ReactNode } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface DataCardProps {
  title?: string
  children: ReactNode
  className?: string
  headerAction?: ReactNode
}

export function DataCard({ title, children, className, headerAction }: DataCardProps) {
  return (
    <Card className={cn('overflow-hidden', className)}>
      {title && (
        <CardHeader className={cn(
          'flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 space-y-0 pb-4 overflow-x-hidden',
          headerAction ? 'pb-4' : 'pb-6'
        )}>
          <CardTitle className="flex-shrink-0">{title}</CardTitle>
          {headerAction && <div className="w-full sm:w-auto flex-shrink-0 min-w-0">{headerAction}</div>}
        </CardHeader>
      )}
      <CardContent className={cn('space-y-4', !title && 'pt-6')}>
        {children}
      </CardContent>
    </Card>
  )
}